import { render, staticRenderFns } from "./duplicateremovalDialog.vue?vue&type=template&id=4b3ca42c&scoped=true&"
import script from "./duplicateremovalDialog.vue?vue&type=script&lang=js&"
export * from "./duplicateremovalDialog.vue?vue&type=script&lang=js&"
import style0 from "./duplicateremovalDialog.vue?vue&type=style&index=0&id=4b3ca42c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3ca42c",
  null
  
)

export default component.exports